import { DefaultTheme } from "styled-components";

import getKeys from "./utils/getKeys";

const fontFamily = `ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"`;

const fonts = {
  DMSans: `DM Sans, ${fontFamily}`,
};

const brandColors = {
  stackOverflow: "#F4933A",
  discord: "#5865F2",
  kaggle: "#20BEFF",
  youtube: "#FF0000",
};

const colors = {
  ...brandColors,
  adornment: "#98999B",
  alabaster: "#FBFBFB",
  algaeGreen: "#8cdeb4",
  aliceBlue: "#F6F9FF",
  atlantis: "#88D337",
  azure: "#3B4EA8",
  background: "#EDEFF1",
  baliHai: "#868AB0",
  bigStone: "#15183d",
  black: "#000000",
  black5: "rgba(27, 29, 34, 0.05)",
  black20: "rgba(27, 29, 34, 0.2)",
  black40: "rgba(27, 29, 34, 0.4)",
  black60: "rgba(27, 29, 34, 0.6)",
  black80: "rgba(27, 29, 34, 0.8)",
  blackPearl: "#080B27",
  blackRock: "#030325",
  blizzardBlue: "#b0e2f9",
  blue: "#2135E5",
  blue5: "#F7F5FF",
  blue10: "#DFE4fB",
  blue20: "rgba(33, 53, 229, 0.2)",
  blue30: "#1427C8",
  blue50: "#ebe9fa",
  blueChalk: "#EBE5FF",
  blueHaze: "#CFD3E5",
  bluePigment: "#3236AC",
  blueRibbon: "#0149E5",
  blueRoyal: "#506DE4",
  blueViolet: "#666FBB",
  bluishPurple: "#753FE6",
  bronze: "#DF7514",
  bronze2: "#F4933A",
  brown: "#3D2E10",
  bunting: "#151a48",
  cadetBlue: "#A8AFBF",
  catskillWhite: "#F3F5F9",
  cavernPink: "#E4B9B9",
  christine: "#ED790F",
  cinnabar: "#EB5642",
  cream: "#FFF8F4",
  crimson: "#BE3536",
  crocusPurple: "#8579FE",
  githubPurple: "#8957E5",
  cyan: "#65DCE3",
  cyanCornflower: "#1883B4",
  darkGreen: "#315903",
  darkVanilla: "#D2D39F",
  deepKoamaru: "#102E7D",
  disabledText: "rgba(27, 29, 34, 0.38)",
  dodgerBlue: "#5959ff",
  ebony: "#131633",
  ebonyDark: "#0C0F27",
  emerald: "#59BA68",
  error: "#FF0B0B",
  fairPink: "#FFEEEC",
  feijoa: "#ADD87B",
  fern: "#66BB79",
  fernFrond: "#3F5C1E",
  flory: "#F17868",
  fog: "#D7DBFF",
  gold: "#F4D255",
  gossip: "#DCFABC",
  gray: "#2d3139",
  gray1: "#FFFFFFB2",
  graySolid1a: "#F5F5F5",
  graySolid2: "#EDEFF1",
  graySolid2a: "#F3F3F4",
  graySolid3: "#DADADB",
  graySolid4: "#BCBDBE",
  graySolid5: "#98999B",
  graySolid6: "#6C6E70",
  graySolid7: "#B2B7BB",
  graysolid8: "#494949",
  green: "#2CE78F",
  green5: "#F6FBF0",
  green10: "#EAFBD6",
  green20: "#9FFF45",
  green30: "#6DC903",
  green60: "#23B55C",
  greenLeaf: "#4B810C",
  haiti: "#0B0E27",
  hintOfGreen: "#E5FFE1",
  iron: "#D2D6DB",
  issueBackground: "#d2d4e0",
  jade: "#00B558",
  lightBlue: "#E8EAFC",
  lightCyan: "#DFF5FF",
  lightHotPink: "#FFBCEC",
  lightPurple: "rgba(166, 174, 185, 0.2)",
  lightYellow: "#FCF9C4",
  lightYellow2: "#FBFFE1",
  limeGreen2: "#B6FB66",
  limeade: "#60B201",
  limeade2: "#5EB000",
  limeade3: "#5CBE00",
  linkWater: "#D2D8F1",
  linkWater2: "#E0E3F8",
  luckyPoint: "#1A2168",
  luckyPoint2: "#1B1D65",
  magenta: "#FC4BCA",
  malibu: "#78AAF9",
  melrose: "#BBC7FF",
  metallicBronze: "#58411F",
  milkPunch: "#FFF5D1",
  navajoWhite: "#ffdeac",
  navyBlue: "#1C284A",
  nileBlue: "#1A3652",
  orange50: "#FEF8EC",
  orange100: "#f9f0d7",
  orange300: "#edd18c",
  orange800: "#674e18",
  paleSky: "#617182",
  parsley: "#24561C",
  peachCream: "#FFF2DE",
  peachDark: "#FF3F3F",
  peachLight: "#FFA8A8",
  peachMedium: "#FF867F",
  pink: "#FAD1D1",
  pistachio: "#65CB06",
  placeboPurple: "#EFEAFF",
  portGore: "#1D214B",
  primary: "#1B1D22",
  purpleBlue: "#4a49c2",
  quineGreen: "#B6FB66",
  red: "#FF0B0B",
  red5: "#FFF6F6",
  red10: "#FFDDD9",
  red20: "#FF6853",
  red40: "#FF0B0B",
  rhino: "#313561",
  royalBlue: "#5C75E7",
  royalOrange: "#F4933A",
  sandyBrown: "#EDA653",
  secondaryText: "rgba(27, 29, 34, 0.6)",
  stratos: "#000036",
  success: "#339900",
  titanWhite: "#EEEEFF",
  transparent: "transparent",
  tundora: "#4B4B4B",
  verdunGreen: "#447C03",
  violet: "#000030",
  vistaWhite: "#FAF1F1",
  waikawaGray: "#525993",
  warning: "#ffcc00",
  white: "#FFFFFF",
  white10: "rgba(255,255,255, 0.1)",
  white20: "rgba(255,255,255, 0.2)",
  wildStrawberry: "#FF267F",
  yellow: "#FFD233",
  yellowGreen: "#B0DF7B",
  zircon: "#EEF1FF",
  zirconLight: "#F1F6FF",
  neutrals400: "#76829D",
  quine20: "#4A49C2",
  neutrals100: "#DFE1E9",
  neutrals300: "#FBFCFF",
  neutrals700: "#383E4D",
  pink10: "#E4E4FF",
  semantic: "#F2EFFB",
  gray100: "#CED1CD",
  caution100: "#FCCC6B",
  crimson100: "#FF6578",
  crimson200: "#F9FBFF",
  cornFlower50: "#E4E7FF",
  gray500: "#636363",
};

const breakpoints = {
  smallXX: 480,
  smallX: 600,
  small: 768,
  medium: 992,
  mediumX: 1024,
  large: 1280,
  largeX: 1440,
};

const breakpointsMaxWidth: Partial<typeof breakpoints> = {};

getKeys(breakpoints).forEach((key) => {
  Object.assign(breakpointsMaxWidth, { [key]: breakpoints[key] - 1 });
});

const media = {
  breakpoint: breakpoints,
  maxWidth: breakpointsMaxWidth as typeof breakpoints,
};

const layout = {
  navbarHeight: 68,
  desktopFooterHeight: 152,
  mobileFooterHeight: 192,

  contributeHeaderDesktopHeight: 268,
  contributeHeaderMobileHeight: 254,
  contributeHeaderDesktopNarrowHeight: 324,

  qccHeaderDesktopHeight: 268,
  qccHeaderMobileHeight: 242,
  qccHeaderDesktopNarrowHeight: 320,

  contributeHeaderDesktopCollapsedHeight: 130,

  rdpHeaderDesktopHeight: 82,

  maintenanceBannerHeight: 29,
  maintenanceBannerMobileHeight: 50,
};

const theme: DefaultTheme = {
  colors,
  fontFamily,
  fonts,
  media,
  layout,
};

export type TColor = keyof typeof colors;

export type TColors = typeof colors;

export type TFontFamily = typeof fontFamily;

export type TFonts = typeof fonts;

export type TMedia = typeof media;

export type TLayout = typeof layout;

export default theme;
